import { get } from 'lodash'

export const getCurrentUserEmail = (state) =>
  get(state, 'appState.user.email', 'unknown')

export const getCurrentUserOffset = (state) =>
  state?.appState?.offset ?? 'unknown'

export const getCurrentPaginationConfig = (state, screen) =>
  state?.appState?.screenPaginationPage?.[screen] ?? {}

export const getScreenScrollOffset = (state, screen) =>
  state?.appState?.screenScrollOffset?.[screen] ?? 0

export const getCategoriesSortingMode = (state) =>
  state?.appState?.categoriesSortingMode ?? false

export const getOrgName = (state) =>
  state?.appState?.user?.orgName ?? ''

// banner is open when isOpenBanner === false
export const getBannerIsOpen = (state, route) => {
  if (state?.appState?.banner?.[route]?.isOpenBanner === false) {
    return true
  } else {
    return false
  }
}
